import { Component, ElementRef, ViewChild, AfterViewInit, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SuiteTechnologiesComponent } from '../../../general/suite-technologies/suite-technologies.component';
import { FaqComponent } from '../../../shared/faq/faq.component';
import { FaqItem } from '../../../models/faq.model';
import { ExploreMoreServicesComponent } from '../explore-more-services/explore-more-services.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactUsComponent } from '../../../shared/contact-us/contact-us.component';

interface TimelineCard {
  id: number;
  year: string;
  title: string;
  description: string;
  image: string;
}

@Component({
  selector: 'app-web-development',
  imports: [CommonModule, SuiteTechnologiesComponent, FaqComponent, ExploreMoreServicesComponent],
  standalone: true,
  templateUrl: './web-development.component.html',
  styleUrl: './web-development.component.scss'
})
export class WebDevelopmentComponent implements AfterViewInit, OnDestroy {
  @ViewChild('featuresSection') featuresSection!: ElementRef;
  @ViewChild('whyChooseSection') whyChooseSection!: ElementRef;
  @ViewChild('heroVideo') heroVideo!: ElementRef<HTMLVideoElement>;
  private jsonLdScript: any;
  isFeaturesVisible = false;
  isWhyChooseVisible = false;

  private observer: IntersectionObserver | null = null;

  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _renderer: Renderer2,
    private modalService: NgbModal
  ) { }

  goToCaseStudies(): void {

  }
  private forcePlayHeroVideo() {
    const video = this.heroVideo?.nativeElement;
    if (!video) return;

    video.muted = true;           // required for autoplay
    video.playsInline = true;

    const play = () => {
      video.play().catch(() => {
        // retry if browser blocks
        setTimeout(() => video.play().catch(() => { }), 300);
      });
    };

    // Ensure it runs after Angular rendering
    setTimeout(play, 100);
  }
  webdevFaqs: FaqItem[] = [
    {
      question: 'What makes your web development services different?',
      answer: `We focus on performance, scalability, and SEO-readiness — ensuring your website 
      not only looks great but also ranks well and converts better.`
    },
    {
      question: 'Do you provide both design and development?',
      answer: `Yes, our web design and development services cover the entire process from 
      UI/UX design to backend integration.`
    },
    {
      question: 'Can you develop eCommerce websites?',
      answer: `Absolutely. We offer ecommerce web development services for both B2B and B2C models 
      with secure payment gateways and intuitive dashboards.`
    },
    {
      question: 'Are your services affordable for startups and small businesses?',
      answer: `Yes, we provide affordable web development services without compromising on 
      quality or technology standards.`
    },
    {
      question: 'Do you offer post-launch support?',
      answer: `Yes, we provide continuous website maintenance, updates, and performance optimization.`
    }
  ];

  @ViewChild('benefitCardsContainer', { static: false }) private benefitCardsContainer!: ElementRef;

  timelinecards: TimelineCard[] = [
    {
      id: 1,
      year: '2020',
      title: 'Custom Website for Cloud Company',
      description: 'We partnered with a cloud consulting company to design and develop a custom website that enhances credibility and online visibility. From wireframing and SEO-optimized content to responsive UI/UX and Azure deployment, our end-to-end solution delivered a high-performing, secure, and user-friendly website, all within just three weeks.',
      image: '../../../../assets/services/web-dev/successStories/Custom-Website-for-Cloud-Company.png'
    },
    {
      id: 2,
      year: '2023',
      title: 'Web-Based Monitoring Solution',
      description: 'We developed a 100% web-based, easy-to-deploy cellular monitoring system that enables users to track equipment performance, receive real-time alerts, and analyze trends effortlessly. With multi-channel notifications, interactive dashboards, and seamless scalability, the solution ensures timely insights and proactive responses for critical operations.',
      image: '../../../../assets/services/web-dev/successStories/Web-Based-Monitoring-Solution.png'
    }
    // {
    //   id: 3,
    //   year: '2025',
    //   title: 'AI-Powered Insurance Application',
    //   description: 'Harnessing the latest in AI and cloud, Kalpita engineered an insurance application that automates claims processing and fraud detection. The application slashed processing times, improved accuracy, and delivered outstanding customer experiences.',
    //   image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=300&fit=crop'
    // }
    // {
    //   id: 4,
    //   year: '2026',
    //   title: 'Future Vision',
    //   description: 'Leading the way in digital transformation and AI-powered solutions.',
    //   image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=300&fit=crop'
    // },
    // {
    //   id: 5,
    //   year: '2027',
    //   title: 'Global Reach',
    //   description: 'Expanding our presence globally with cutting-edge technology solutions.',
    //   image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=400&h=300&fit=crop'
    // }
  ];

  selectedIndex = 1; // Start with middle card selected

  // THIS IS THE FIX: All instances of 'this.cards' are changed to 'this.timelinecards'
  get visibleCards(): Array<{ card: TimelineCard, position: 'top' | 'center' | 'bottom' }> {
    const result = [];

    // Top card
    if (this.selectedIndex > 0) {
      result.push({
        card: this.timelinecards[this.selectedIndex - 1],
        position: 'top' as const
      });
    }

    // Center card (selected)
    result.push({
      card: this.timelinecards[this.selectedIndex],
      position: 'center' as const
    });

    // Bottom card
    if (this.selectedIndex < this.timelinecards.length - 1) {
      result.push({
        card: this.timelinecards[this.selectedIndex + 1],
        position: 'bottom' as const
      });
    }

    return result;
  }

  // THIS IS THE FIX: Changed 'this.cards' to 'this.timelinecards'
  get showCarouselDots(): boolean {
    return this.timelinecards.length > 3;
  }

  selectCard(position: 'top' | 'center' | 'bottom'): void {
    if (position === 'top' && this.selectedIndex > 0) {
      this.selectedIndex--;
    } else if (position === 'bottom' && this.selectedIndex < this.timelinecards.length - 1) {
      this.selectedIndex++;
    }
  }

  // THIS IS THE FIX: Changed 'this.cards' to 'this.timelinecards'
  goToCard(index: number): void {
    if (index >= 0 && index < this.timelinecards.length) {
      this.selectedIndex = index;
    }
  }

  get canScrollUp(): boolean {
    return this.selectedIndex > 0;
  }

  get canScrollDown(): boolean {
    return this.selectedIndex < this.timelinecards.length - 1;
  }

  whyChooseFeatures = [
    {
      icon: '../../../../assets/services/web-dev/whyChooseUs/ProvenIndustryExpertise.png',
      title: 'Proven Industry Expertise ',
      description: 'For over 7+ years, we’ve been building custom software applications for industries like Insurtech, Fintech, Healthcare, E-commerce, and Hi-Tech. Every solution is custom-made to fit business workflows, not force you into rigid systems.'
    },
    // {
    //   icon: '../../../../assets/home/industries/healthcare_icon.png',
    //   title: 'Enterprise-Grade Security',
    //   description: 'As a SOC II Certified organization, we guarantee top-tier security, reliability, and compliance, protecting your data at every level.'
    // },
    {
      icon: '../../../../assets/services/web-dev/whyChooseUs/GlobalDeliveryAdvantage.png',
      title: 'Global Delivery Advantage',
      description: 'With strong presence and experience in both the USA & India markets, we blend global standards with local insights to build solutions that truly perform.'
    },
    {
      icon: '../../../../assets/services/web-dev/whyChooseUs/HighlySkilledWebSpecialists.png',
      title: 'Highly Skilled Web Specialists',
      description: 'Our Full Stack Developers and UI/UX Designers bring deep technical expertise to build beautiful, functional, and scalable digital experiences.'
    },
    {
      icon: '../../../../assets/services/web-dev/whyChooseUs/Faster-Time-to-Value.png',
      title: 'Faster Time-to-Value',
      description: 'Through an agile and transparent development workflow, we accelerate delivery while ensuring measurable results and a strong ROI.'
    }
  ];

  developmentProcess = [
    {
      icon: '../../../../assets/services/web-dev/developmentProcess/DiscoveryConsultation.png',
      title: 'Discovery & Consultation',
      description: 'Understand your goals, audience, and brand identity.'
    },
    {
      icon: '../../../../assets/services/web-dev/developmentProcess/PlanningWireframing.png',
      title: 'Planning & Wireframing',
      description: 'Define the website structure, UI/UX flow, and technical roadmap.'
    },
    {
      icon: '../../../../assets/services/web-dev/developmentProcess/DesignDevelopment.png',
      title: 'Design & Development',
      description: 'Craft visually appealing, responsive, and functional websites using latest AI technologies with manual touch.'
    },
    {
      icon: '../../../../assets/services/web-dev/developmentProcess/TestingOptimization.png',
      title: 'Testing & Optimization',
      description: 'Rigorously test for performance, speed, and cross-browser compatibility.'
    },
    {
      icon: '../../../../assets/services/web-dev/developmentProcess/LaunchSupport.png',
      title: 'Launch & Support',
      description: 'Deploy your website and provide continuous improvement & support.'
    }
  ];

  // Service Overview section data and logic
  services = [
    {
      title: 'Faster Time to Market',
      description: 'We design software that grows with your business and adapts to new technologies.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    },
    {
      title: 'Secure & Compliant',
      description: 'Our agile development process ensures quick and efficient delivery of your software.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    },
    {
      title: 'Innovation at Core',
      description: 'We build robust and secure software that complies with industry standards.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    },
    {
      title: 'Future-Ready Architecture',
      description: 'We leverage the latest technologies to build innovative and cutting-edge software.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    },
    {
      title: 'End to End Support',
      description: 'We provide comprehensive support and maintenance services for your software.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    }
  ];
  selectedServiceIndex = 3; // Default to "Future-Ready Architecture"

  // Pre-defined positions for the icons on the arc and the active position
  private arcPositions = [
    { x: -180, y: 80 },
    { x: -110, y: -20 },
    { x: 0, y: -60 },
    { x: 110, y: -20 },
    { x: 180, y: 80 }
  ];
  private activePosition = { x: 0, y: 150 };

  selectService(index: number): void {
    this.selectedServiceIndex = index;
  }

  getPointTransform(index: number): string {
    let pos;
    if (index === this.selectedServiceIndex) {
      pos = this.activePosition;
    } else {
      pos = this.arcPositions[index];
    }
    return `translate(${pos.x}px, ${pos.y}px)`;
  }

  readMore(): void {
  }
  ngOnInit(): void {
    this.injectSchemaMarkup();
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  injectSchemaMarkup(): void {
    const webDevSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/company-services/web-development#webpage",
          "url": "https://www.kalpitatechnologies.com/company-services/web-development",
          "name": "Web Development Services | Custom Websites & Web Apps | Kalpita Technologies",
          "description": "Professional web development services by Kalpita Technologies — custom websites, web applications, eCommerce platforms, and CMS development.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en-US",
          "datePublished": "2026-01-22"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/company-services/web-development#breadcrumbs",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com/" },
            { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://www.kalpitatechnologies.com/company-services" },
            { "@type": "ListItem", "position": 3, "name": "Web Development", "item": "https://www.kalpitatechnologies.com/company-services/web-development" }
          ]
        },
        {
          "@type": "Service",
          "@id": "https://www.kalpitatechnologies.com/company-services/web-development#service",
          "name": "Web Development Services",
          "serviceType": "Web Development",
          "provider": { "@id": "https://www.kalpitatechnologies.com/#organization" },
          "description": "End-to-end custom web development services designed to help businesses build impactful digital experiences including custom web apps and eCommerce."
        },
        {
          "@type": "HowTo",
          "@id": "https://www.kalpitatechnologies.com/company-services/web-development#dev-process",
          "name": "Step-by-Step Custom Web Development Process",
          "step": [
            { "@type": "HowToStep", "position": 1, "name": "Discovery", "text": "Understand your business goals, target audience, and brand identity." },
            { "@type": "HowToStep", "position": 2, "name": "Planning", "text": "Define the website structure, UI/UX flow, and technical roadmap." },
            { "@type": "HowToStep", "position": 3, "name": "Development", "text": "Craft visually appealing, responsive, and functional websites." },
            { "@type": "HowToStep", "position": 4, "name": "Testing", "text": "Rigorously test for performance, speed, and cross-browser compatibility." },
            { "@type": "HowToStep", "position": 5, "name": "Launch", "text": "Deploy your website and provide continuous improvement." }
          ]
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/company-services/web-development#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What makes your web development services different?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We focus on performance, scalability, and SEO-readiness — ensuring your website ranks well and converts better."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this._renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(webDevSchema);
    this._renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this._renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  setupTiltEffect(): void {
    const cards = document.querySelectorAll('.feature-card, .features-img');

    cards.forEach(card => {
      const cardEl = card as HTMLElement;

      const mouseMoveHandler = (e: MouseEvent) => {
        const rect = cardEl.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xc = rect.width / 2;
        const yc = rect.height / 2;

        const maxRotate = 10;

        const rotateY = ((x - xc) / xc) * maxRotate;
        const rotateX = ((yc - y) / yc) * maxRotate;

        cardEl.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
      };

      const mouseLeaveHandler = () => {
        cardEl.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
      };

      const mouseEnterHandler = () => {
        // Switch to fast transition for smooth tilt effect on hover
        cardEl.style.transition = 'transform 0.1s ease-out, box-shadow 0.2s ease-in-out, background 0.2s ease';
      };

      cardEl.addEventListener('mousemove', mouseMoveHandler as EventListener);
      cardEl.addEventListener('mouseleave', mouseLeaveHandler as EventListener);
      cardEl.addEventListener('mouseenter', mouseEnterHandler as EventListener);

      if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
        cardEl.removeEventListener('mousemove', mouseMoveHandler as EventListener);
        cardEl.style.transform = 'none';
      }
    });
  }

  setupScrollAnimation(): void {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {

          if (this.featuresSection && entry.target === this.featuresSection.nativeElement) {
            this.isFeaturesVisible = true;
            observer.unobserve(entry.target);
          }

          if (this.whyChooseSection && entry.target === this.whyChooseSection.nativeElement) {
            this.isWhyChooseVisible = true;
            observer.unobserve(entry.target);
          }
        }
      });
    }, {
      threshold: 0.2 // Trigger when 20% visible
    });

    if (this.featuresSection) {
      observer.observe(this.featuresSection.nativeElement);
    }

    if (this.whyChooseSection) {
      observer.observe(this.whyChooseSection.nativeElement);
    }

    this.observer = observer;
  }
  ngAfterViewInit(): void {
    this.forcePlayHeroVideo();
    this.setupTiltEffect();
    this.setupScrollAnimation();
    const cards = document.querySelectorAll('.feature-card, .features-img');

    cards.forEach(card => {
      const cardEl = card as HTMLElement;

      const mouseMoveHandler = (e: MouseEvent) => {
        const rect = cardEl.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Calculate center
        const xc = rect.width / 2;
        const yc = rect.height / 2;

        // Max rotation degrees
        const maxRotate = 10;

        // Calculate rotation based on cursor position
        const rotateY = ((x - xc) / xc) * maxRotate;
        const rotateX = ((yc - y) / yc) * maxRotate; // Inverse Y axis

        // Apply transform
        cardEl.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
      };

      const mouseLeaveHandler = () => {
        // Reset to flat state
        cardEl.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
      };

      const mouseEnterHandler = () => {
        // Smooth entry
        cardEl.style.transition = 'transform 0.1s ease-out, box-shadow 0.2s ease-in-out, background 0.2s ease';
      };

      // Attach Listeners
      cardEl.addEventListener('mousemove', mouseMoveHandler as EventListener);
      cardEl.addEventListener('mouseleave', mouseLeaveHandler as EventListener);
      cardEl.addEventListener('mouseenter', mouseEnterHandler as EventListener);

      // Optional: Disable on touch devices for better scrolling
      if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
        cardEl.removeEventListener('mousemove', mouseMoveHandler as EventListener);
        cardEl.style.transform = 'none';
      }
    });
  }

  getAFreeQuote(): void {
    this.modalService.open(ContactUsComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: 'contact-modal'
    });
  }

  bookAFreeCall(): void {
    this.getAFreeQuote();
  }
}
